export default __webpack_public_path__ + "static/media/pdf.ddb62146.svg";